import _ from 'lodash';
import { IObservation, IObservationType, IUser } from 'src/Definitions';
import { IdentifierEntityDto, IObservationDto, ObservationTypeDto } from 'src/generated_client';

export default class ObservationEditorLogic {
    public getObservationDescriptionOrDefault(
        observation: IObservationDto | undefined,
        behaviorId: string | undefined
    ) {
        if (observation && behaviorId && observation.behaviorId === behaviorId) {
            return observation.observationDescription;
        }
        return '';
    }

    public getObservationTypeNameOrDefault(
        observation: IObservationDto | undefined,
        behaviorId: string | undefined
    ) {
        if (observation && observation.observationType && behaviorId === observation.behaviorId) {
            return observation.observationType.observationTypeName;
        }
        return 'Rose';
    }

    public getObservationType(
        observationTypes: IObservationType[] | undefined,
        selectedType: string
    ) {
        if (observationTypes && selectedType) {
            const observationType = _.find(
                observationTypes,
                (type) => type.observationTypeName === selectedType
            );
            return new ObservationTypeDto({ ...observationType });
        }
        return new ObservationTypeDto();
    }

    public hasObservationChanged(currentObservation: IObservation | undefined) {
        return currentObservation ? currentObservation.isModified : false;
    }

    public getObserver(user: IUser | undefined, observation: IObservation | undefined) {
        if (!observation) {
            return new IdentifierEntityDto({
                ...user,
            });
        } else {
            return observation.observer;
        }
    }

    public shouldDisableAttachmentButton(behaviorId?: string, observation?: IObservation) {
        return observation
            ? observation.isModified === true ||
                  observation.id === undefined ||
                  (behaviorId !== undefined && observation!.behaviorId !== behaviorId)
            : true;
    }
}



// WEBPACK FOOTER //
// ./src/chevrons/behaviors/observations/ObservationEditorLogic.ts